// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2CzFO","title":"BackImages_title__XF-AU","images":"BackImages_images__HxI6O"};